import React, {Component} from 'react';
import {NavLink} from 'react-router-dom'

import {BASE_PATH} from "../../../../wpconfig";

class JournalItem extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const record = this.props.record;
		return (
			<div className="document-list-item">
				<NavLink to={BASE_PATH + "journal/?record_id=" + record.journal_id}
				         className="item-subject">{record.journal_title}</NavLink>
				{rmVars.isEditor &&
				<a href={rmVars.homeUrl + "?page=journal&record_id=" + record.journal_id}
				   target="_blank"
				   className="ml-2"><span className="editor-edit"></span></a>
				}
				<div className="item-info">
					<div className="info-cell"><strong>
						{record.issn.includes('-') ?  'ISSN ' + record.issn : ''}
						{(record.issn.includes('-')) && (record.eissn.includes('-')) ? ' / ' : ''}
						{(record.eissn.includes('-')) ? 'E-ISSN ' + record.eissn:''}
					</strong></div>
					<div className="info-cell"><strong>Publisher</strong> {record.publisher}</div>
					{record.birth_year &&
					<div className="info-cell">{record.birth_year}</div>
					}
				</div>
				{(record.journal_ranking && record.journal_ranking.length > 0 || record.registered_db) &&
				<div className="item-options">
					<div className="options-cell">
						<div className="badge-group">
							<div className="badge-group-inner">
								{record.journal_ranking && record.journal_ranking.map((item, num) => {
									let className = 'badge bg-lightpurple rounded-0';
									if (!item.percent || !item.name)
										return;
									// item.name = item.name.toUpperCase()
									if (item.name.includes('KCI'))
										className = 'badge bg-lightgreen rounded-0';
									else if (item.name.includes('Scopus'))
										className = 'badge bg-lightorange rounded-0';
									return (
										<div key={num} className={className}>{item.name} {item.year} (Top {item.percent}%)</div>
									)
								})}
							{record.registered_db && record.registered_db.map((item, num) => {
								let className = 'badge bg-lightpurple';
								if (!item.name)
									return;
								// item.name = item.name.toUpperCase()
								if (item.name.includes('KCI'))
									className = 'badge bg-lightgreen';
								else if (item.name.includes('Scopus'))
									className = 'badge bg-lightorange';
								else if (item.name.includes('Nature Index'))
									className = 'badge bg-skyblue';
								return (
									<div key={num} className={className}>{item.name}</div>
								)
							})}
							</div>
						</div>
					</div>
					<div className="options-cell">
						{record.resource_count &&
						<NavLink to={BASE_PATH + "resources/?journal_id[]=" + record.journal_id}
						         className="color-lightblack">PNU Articles ({record.resource_count})</NavLink>
						}
					</div>
				</div>
				}
			</div>
		)
	}
}

export default JournalItem;

// Journals.propTypes = {
//     monitor_box_status: PropTypes.bool,
//     listStatus: PropTypes.array,
//     id: PropTypes.string,
//     companyStatus: PropTypes.string,
//     companyName: PropTypes.string,
//     address: PropTypes.string,
//     reportID: PropTypes.string,
//     isUserList: PropTypes.string,
//     createDate: PropTypes.string,
//     startDate: PropTypes.string,
//     endDate: PropTypes.string,
//     advertiserName: PropTypes.string,
//     advertiserPhone: PropTypes.string,
//     operatorPhone: PropTypes.string,
//     operatorName: PropTypes.string,
//     reportKeywords: PropTypes.array,
//     monitoringInfo: PropTypes.string,
// };
